<template>
  <div class="page-wrap">
    <img src="@/assets/images/login-img.jpg" alt="" class="left-img">
    <div class="main-wrap">
      <div class="head">
        <img src="@/assets/images/logo.png" alt="" class="logo">
        <div class="title">先行者-售后服务平台</div>
      </div>
      <div class="form">
        <div class="form-item">
          <input type="text" v-model="form.username" placeholder="请输入用户名">
        </div>
        <div class="form-item">
          <input type="password" v-model="form.password" placeholder="请输入密码">
        </div>
        <div class="form-item">
          <input type="text" v-model="captchaCode" placeholder="输入验证码">
          <img :src="codeImg" alt="" class="code" @click="getCode">
        </div>
        <el-button type="primary" class="submit" @click="submit" :loading="loading">登录</el-button>
      </div>
      <div class="foot">
        <div>Copyright © 2021 宁波先行者科技有限公司</div>
        <div>浙ICP备14018012号-2</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        username: '',
        password: '',
        userType: 'CUSTOMER'
      },
      captchaCode: '',
      codeImg: '',
      captchaKey: '',
      loading: false
    }
  },
  created(){
    this.getCode()
  },
  methods: {
    submit(){
      if(!this.form.username || !this.form.password){
        this.$message({
          message: '账号和密码不能为空',
          type: 'error'
        });
      }
      else if(!this.captchaCode){
        this.$message({
          message: '验证码不能为空',
          type: 'error'
        });
      }
      else{
        this.loading = true
        this.$axios.post('/public/verify-captcha',{
          captchaCode: this.captchaCode,
          captchaKey: this.captchaKey
        }).then(res=>{
          this.$axios.post('/login',this.form).then(res=>{
            this.loading = false
            localStorage.setItem('token',res.data.id_token)
            localStorage.setItem('userinfo',JSON.stringify(res.data.user))
            this.$router.push('/home')
          }).catch(()=>{
            this.loading = false
          })
        }).catch(err=>{
          this.loading = false
          this.getCode()
        })
      }
    },
    getCode(){
      this.$axios.get('/public/captcha').then(res=>{
        this.codeImg = res.data.image
        this.captchaKey = res.data.captchaKey
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrap{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  .left-img{
    height: 100%;
    width: auto;
  }
  .main-wrap{
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    position: relative;
    .head{
      display: flex;
      flex-direction: column;
      align-items: center;
      .logo{
        width: 122px;
        margin-bottom: 40px;
      }
      .title{
        font-size: 28px;
        color: #4B72FE;
        line-height: 1;
      }
    }
    .form{
      padding: 100px 0;
      width: 390px;
      .form-item{
        background-color: #F1F3F8;
        border-radius: 10px;
        height: 52px;
        display: flex;
        padding: 0 20px;
        border: 1px solid transparent;
        margin-bottom: 20px;
        &:hover{
          border: 1px solid #4B72FE;
        }
        input{
          flex: 1;
          outline: none;
          border: none;
          font-size: 16px;
          color: #222;
          background-color: transparent;
          &::-webkit-input-placeholder{
            color: #9DA5BB;
          }
        }
        img.code{
          mix-blend-mode: multiply;
        }
      }
      .submit{
        background-color: #4B72FE;
        border-color: #4B72FE;
        display: block;
        width: 100%;
        height: 52px;
        margin-top: 30px;
        border-radius: 10px;
        &:active{
          background-color: #1e48df;
          border-color: #1e48df;
        }
      }
    }
    .foot{
      width: 100%;
      position: absolute;
      bottom: 50px;
      display: flex;
      justify-content: space-between;
      padding: 0 100px;
      font-size: 14px;
      color: #777;
    }
  }
}
</style>